<template>
  <div id="app" class="min-h-screen bg-slate-50 text-slate-900">
    <ToastContainer />
    <router-view />
  </div>
</template>

<script setup>
import ToastContainer from "@/components/ToastContainer.vue";
</script>

<style>
#app {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
